import {Component, forwardRef, Input} from "@angular/core";
import {SearchAction, SearchActionSelector} from "../../entity/search/search-grid/actions/search-action.component";
import {EntityModel, SearchModel} from "@fedeltapointofsale/data-client";
import {FUIAlertAction, FUIAlertActions, FUIAlertService} from "@fedeltapointofsale/ui";
import {AnalyticsService} from "../../../analytics/analytics.service";
import {AnalyticEvent} from "../../../analytics/analytic-event";
import {firstValueFrom} from "rxjs";

/**
 * SearchAction to delete a record from the grid.
 */
@Component({
    selector: "wbo-delete-search-action",
    template: "",
    providers: [
        {provide: SearchActionSelector, useExisting: forwardRef(() => DeleteSearchActionComponent), multi: true}
    ]
})
export class DeleteSearchActionComponent implements SearchAction {
    static readonly DELETE_NAME: string = "wbo.common.button.delete";
    static readonly DELETE_ICON: string = "delete";
    static readonly IMPORTANCE: number = 50;

    @Input() removeHeading: string = "wbo.search.prompt.remove.heading";
    @Input() removeMessage: string = "wbo.search.prompt.remove.message";
    @Input() availableCallback: (data: any) => boolean;
    @Input() deleteEntity: (data: any) => Promise<any>;
    @Input() callbackContext: any;

    private available: boolean = false;

    constructor(public searchModel: SearchModel<any>, private entityModel: EntityModel<any>, private alertService: FUIAlertService,
                private analyticsService: AnalyticsService) {
        this.entityModel.canDeleteEntity().then((canDelete: boolean) => this.available = canDelete);
    }

    getImportance(): number {
        return DeleteSearchActionComponent.IMPORTANCE;
    }

    getIcon(data: any): string {
        return DeleteSearchActionComponent.DELETE_ICON;
    }

    getIconClass(data: any): string {
        return "";
    }

    getIconSize(data: any): number {
        return 17;
    }

    getName(data: any): string {
        return DeleteSearchActionComponent.DELETE_NAME;
    }

    async doAction(data: any): Promise<any> {
        const action: FUIAlertAction = await firstValueFrom(this.alertService.showConfirmationOkCancel(this.removeHeading, this.removeMessage));
        if (action === FUIAlertActions.OK_ACTION) {
            this.analyticsService.trackEvent(AnalyticEvent.SEARCH_DELETE_ROW, this.searchModel);
            if (this.deleteEntity) {
                return this.deleteEntity.bind(this.callbackContext)(data);
            } else {
                return this.entityModel.deleteEntity(this.searchModel.getIdentifier(data));
            }
        }
    }

    isAvailable(data: any): boolean {
        if (!this.available) {
            return false;
        }
        if (this.availableCallback) {
            return this.availableCallback.bind(this.callbackContext)(data);
        }
        return true;
    }
}
